define('models/onboarding/tutorial',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
], function(
    _, Backbone, U,
    // services
    API
) {

    var MOnboardingTutorial = Backbone.Epoxy.Model.extend({
        idAttribute: '_id'
    });

    // Return the model for the module
    return MOnboardingTutorial;
});

